import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { ActividadGrupoEspecie } from '@rpe/registro-personas-empresas-lib';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityActividadesGrupoEspecieAdapter: EntityAdapter<ActividadGrupoEspecie> =
  createEntityAdapter<ActividadGrupoEspecie>({
    selectId: (model) => model.id,
    sortComparer: (a: ActividadGrupoEspecie, b: ActividadGrupoEspecie): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityActividadesGrupoEspecieState extends EntityState<ActividadGrupoEspecie> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityActividadesGrupoEspecieState =
  entityActividadesGrupoEspecieAdapter.getInitialState({
    isLoading: false,
    error: null
  });
